module.exports = __webpack_public_path__ + "img/Link.017842a4.svg";